<template>
  <div class="page">
    <van-row type="flex" justify="center">
      <van-col span="22">
        <div>
          <div class="sechout">
            <div class="sech-left" @click="back()">
              <van-icon name="arrow-left" color="#181616" size="20" />
            </div>
            <div class="sech-title">缴费记录</div>
            <div class="sech-right"></div>
          </div>
          <div class="content">
            <img @click="toDetail" class="recordCard" src="../../../../assets/house/property/recordCard.png" alt="">
            <img @click="toDetail" class="recordCard" src="../../../../assets/house/property/recordCard.png" alt="">
            <img @click="toDetail" class="recordCard" src="../../../../assets/house/property/recordCard.png" alt="">
          </div>
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
  export default {
    methods: {
      back() {
        this.$router.go(-1);
      },
      toDetail() {
        this.$router.push('/house/property/propertyPayCostDetail')
      }
    }
  }
</script>

<style lang="less" scoped>
  .page {
    height: 100%;
    background-color: #f5f5f5;
  }

  .sechout {
    padding-top: 22px;
    margin-bottom: 16px;
    height: 44px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .sech-left,
  .sech-right {
    width: 104px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .sech-title {
    font-size: 17px;
    font-weight: 500;
    color: #222325;
  }

  .content {
    border-radius: 6px;
    margin-bottom: 20px;
    padding-bottom: 44px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .recordCard {
    width: 100%;
    margin-bottom: 12px;
  }
</style>